import { createApp } from 'vue';
import ProductHighlightsBlock from './ProductHighlightsBlock.vue';
import store from 'shared/store';

const productHighlightsBlockElems = document.querySelectorAll(
	'[data-feature="product-highlights-block"]'
);
if (productHighlightsBlockElems) {
	productHighlightsBlockElems.forEach((elem) => {
		const app = createApp({
			name: 'ProductHighlightsBlockApp',
		});
		app.use(store);
		app.component('product-highlights-block', ProductHighlightsBlock);
		app.mount(elem);
	});
}
